'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { toast } from 'sonner';

// Backend integration point: replace with /api/admin/verification-queue
const queue = [
  { id: 'vq-001', listing: 'The Pearl Doha 2BR', agent: 'Hassan Al-Thani', type: 'DLD Permit', urgency: 'urgent', submittedDate: '07 Jun 2026' },
  { id: 'vq-002', listing: 'Business Bay Studio', agent: 'Ravi Kumar', type: 'Agent License', urgency: 'normal', submittedDate: '06 Jun 2026' },
  { id: 'vq-003', listing: 'DIFC Office Suite', agent: 'Tariq Al-Qassim', type: 'Title Deed', urgency: 'urgent', submittedDate: '05 Jun 2026' },
  { id: 'vq-004', listing: 'Riyadh Hills Villa 5BR', agent: 'Mohammed Al-Saud', type: 'Ownership Docs', urgency: 'normal', submittedDate: '04 Jun 2026' },
  { id: 'vq-005', listing: 'JBR Beachfront Studio', agent: 'Priya Sharma', type: 'Agency License', urgency: 'low', submittedDate: '03 Jun 2026' },
  { id: 'vq-006', listing: 'Mamsha Al Saadiyat 4BR', agent: 'Sara Al-Mansoori', type: 'DLD Permit', urgency: 'urgent', submittedDate: '07 Jun 2026' },
  { id: 'vq-007', listing: 'Downtown Dubai Sky Tower', agent: 'Sara Al-Mansoori', type: 'Escrow Account', urgency: 'normal', submittedDate: '02 Jun 2026' },
];

const urgencyColors: Record<string, string> = {
  urgent: 'bg-red-50 text-red-700 border-red-200',
  normal: 'bg-amber-50 text-amber-700 border-amber-200',
  low: 'bg-blue-50 text-blue-700 border-blue-200',
};

export default function VerificationQueue() {
  return (
    <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">
      <div className="flex items-center justify-between p-5 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="ShieldCheckIcon" size={18} className="text-primary" />
          <h3 className="font-bold text-foreground text-base">Verification Queue</h3>
        </div>
        <span className="bg-red-50 text-red-700 border border-red-200 text-xs font-bold px-2.5 py-1 rounded-full">
          {queue.length} pending
        </span>
      </div>

      <div className="divide-y divide-border">
        {queue.map((item) => (
          <div key={item.id} className="p-4 hover:bg-muted/30 transition-colors group">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-foreground text-xs line-clamp-1">{item.listing}</div>
                <div className="text-muted-foreground text-xs mt-0.5">{item.agent}</div>
              </div>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border flex-shrink-0 ${urgencyColors[item.urgency]}`}>
                {item.urgency}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1.5">
                <Icon name="DocumentTextIcon" size={12} className="text-muted-foreground" />
                <span className="text-xs text-muted-foreground">{item.type}</span>
                <span className="text-border">•</span>
                <span className="text-xs text-muted-foreground">{item.submittedDate}</span>
              </div>
              <div className="flex items-center gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
                <button
                  onClick={() => toast.success(`${item.listing} verified`)}
                  className="w-6 h-6 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-500 hover:text-white transition-all"
                  aria-label="Verify"
                >
                  <Icon name="CheckIcon" size={12} />
                </button>
                <button
                  onClick={() => toast.error(`${item.listing} rejected`)}
                  className="w-6 h-6 rounded-lg bg-red-50 text-red-500 flex items-center justify-center hover:bg-red-500 hover:text-white transition-all"
                  aria-label="Reject"
                >
                  <Icon name="XMarkIcon" size={12} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}